<template>
  <FKBreadCrumb :page="$t('page.edit')" :title="$t('page.edit_user')">
    <!-- <FKBreadCrumbItem :page="$t('page.system_users')" to="/system-users" /> -->
    <FKBreadCrumbItem :page="user_fullname" :to="`/user/${user_id}`" />
  </FKBreadCrumb>
  <UserForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import UserForm from "@/components/FK/UserForm/UserForm.vue";
import { UserInfo } from "@/utils/models/user.model";

export default defineComponent({
  name: "UpdateUserPage",
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    UserForm,
  },
  computed: {
    user_fullname(): string {
      const user = this.$route.meta.user as UserInfo;
      return `${user.firstname} ${user.lastname}`;
    },
    user_id(): string {
      const user = this.$route.meta.user as UserInfo;
      return user.id;
    }
  }
});
</script>